import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider } from "@/context/AppContext";
import { AuthProvider } from "@/context/AuthContext";

import PublicLayout from "@/components/layout/PublicLayout";
import { Navigate } from "react-router-dom";
import Home from "@/pages/Home";
import Projects from "@/pages/Projects";
import ProjectDetail from "@/pages/ProjectDetail";
import Locations from "@/pages/Locations";
import LocationDetail from "@/pages/LocationDetail";
import Guides from "@/pages/Guides";
import ThankYou from "@/pages/ThankYou";
import Compare from "@/pages/Compare";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Requirements from "@/pages/Requirements";
import Legal from "@/pages/Legal";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import AdminLeads from "@/pages/admin/AdminLeads";
import AdminProperties from "@/pages/admin/AdminProperties";
import AdminProjects from "@/pages/admin/AdminProjects";
import AdminLocations from "@/pages/admin/AdminLocations";
import AdminSettings from "@/pages/admin/AdminSettings";

function App() {
  return (
    <AppProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/properties" element={<Navigate to="/projects" replace />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:slug" element={<ProjectDetail />} />
              <Route path="/locations" element={<Locations />} />
              <Route path="/locations/:slug" element={<LocationDetail />} />
              <Route path="/guides" element={<Guides />} />
              <Route path="/thank-you" element={<ThankYou />} />
              <Route path="/compare" element={<Compare />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/requirements" element={<Requirements />} />
              <Route path="/privacy-policy" element={<Legal type="privacy" />} />
              <Route path="/terms" element={<Legal type="terms" />} />
              <Route path="/rera-disclaimer" element={<Legal type="rera" />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminLayout />}>
              <Route index element={<Dashboard />} />
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="leads" element={<AdminLeads />} />
              <Route path="properties" element={<AdminProperties />} />
              <Route path="projects" element={<AdminProjects />} />
              <Route path="locations" element={<AdminLocations />} />
              <Route path="settings" element={<AdminSettings />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </AppProvider>
  );
}

export default App;
